// Minimal RIaS-style helper for lazysizes
// Builds data-srcset from data-src + data-widths where data-src contains "{width}" 
(function(){
  function parseWidths(attr){
    if(!attr) return [];
    try {
      var val = attr.trim();
      return JSON.parse(val);
    } catch(e){
      // fallback: split by comma
      return attr.replace(/[\[\]\s]/g,'').split(',').map(function(s){ return parseInt(s,10) }).filter(Boolean);
    }
  }
  function buildSrcset(pattern, widths){
    var out = [];
    for (var i=0;i<widths.length;i++){
      var w = widths[i];
      var url = pattern.replace(/\{width\}/g, String(w));
      out.push(url + ' ' + w + 'w');
    }
    return out.join(', ');
  }
  document.addEventListener('lazybeforeunveil', function(e){
    var el = e.target;
    if (!el || el.tagName !== 'IMG') return;
    if (el.getAttribute('data-srcset')) return; // already present
    var pattern = el.getAttribute('data-src') || '';
    if (pattern.indexOf('{width}') === -1) return;
    var widthsAttr = el.getAttribute('data-widths') || '';
    var widths = parseWidths(widthsAttr);
    if (!widths.length) return;
    var srcset = buildSrcset(pattern, widths);
    el.setAttribute('data-srcset', srcset);
  }, {capture:true, passive:true});
})(); 
